import { render, staticRenderFns } from "./ProjectFilterList.vue?vue&type=template&id=0c90836f&"
import script from "./ProjectFilterList.vue?vue&type=script&lang=js&"
export * from "./ProjectFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports